const referralPartnerReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_REFERRALS':
            const newState = action.payload;
            return newState;
        case 'UNSET_REFERRALS':
            return [];
        default:
            return state;
    }
};

export default referralPartnerReducer;